import React, { useContext, useState } from 'react'
import { BlogContext, BlogProvider } from './BlogContext'
import HTag from '@/lib/HTag'
import { Link } from 'gatsby'
import Search from '@/lib/Search'
import ArticlePreviewSm from './ArticlePreviewSm'
import clsx from 'clsx'

const App = ({ heading, pattern }) => {
	const { posts } = useContext(BlogContext)
	const [$query, set$query] = useState(null)
	const [$results, set$results] = useState([])

	function onKeyUp({ target }) {
		set$query(target.value)

		const results = posts.filter(post => post.title.toLowerCase().includes(target.value.toLowerCase()))
		set$results(results)
	}

	return (
		<section className={clsx('py-8 px-4 relative z-[1]', pattern)}>
			<div className="grid md:grid-cols-[auto,1fr] gap-y-4 gap-x-8 items-center max-w-screen-xl mx-auto">
				<HTag
					className="h2 <md:text-3xl shrink-0"
					tag={heading.tag}
					text={<Link to="/blog">{heading.text}</Link>}
				/>

				<Search
					className="w-full text-grounding-navy"
					query={$query}
					results={$results}
					resultComponent={ArticlePreviewSm}
					onKeyUp={onKeyUp}
				/>
			</div>
		</section>
	)
}

const BlogSearch = props => <BlogProvider children={<App {...props} />} />

export default BlogSearch
